import { useMutation } from '@connectrpc/connect-query'
import { updateBiddingIntradayOrder } from '@ebalance/proto/bffuser/v1/bidding_intraday_service-BiddingIntradayService_connectquery'
import { useQueryClient } from '@tanstack/react-query'

import { biddingQueryKeys } from '~/hooks/bidding/queryKeys'
import { invalidateIntradayPreviewsOnRejection } from '~/hooks/bidding/useCreateBiddingIntradayOrder'
import { useWorkflowCaseScopedMutation } from '~/hooks/bidding/useWorkflowCaseScopedMutation'
import type { InvalidatingMutationResultFor } from '~/hooks/useInvalidatingMutation'

/**
 * 時間前注文 更新 mutation hook (楽観ロック使用)。
 *
 * 手数料自動考慮・フォーミュラの理由で拒否された時は、 開いたままの編集フォームが突き合わせている
 * プレビューを取り直す (作成と同じ。 AC-BIN-004b / AC-BIN-104 / AC-BIN-020)。 編集フォームの欄名・
 * 検証は開いた時点の扱いで決まり、 入札制限の設定の ON/OFF とは突き合わせないので、 作成と違って
 * 入札制限の設定は取り直さない。
 */
export function useUpdateBiddingIntradayOrder(): InvalidatingMutationResultFor<
  typeof updateBiddingIntradayOrder
> {
  const queryClient = useQueryClient()
  return useWorkflowCaseScopedMutation(
    useMutation(updateBiddingIntradayOrder, {
      onSuccess: () =>
        Promise.all([
          queryClient.invalidateQueries({
            queryKey: biddingQueryKeys.intradayList,
          }),
          queryClient.invalidateQueries({
            queryKey: biddingQueryKeys.intradayDetail,
          }),
        ]),
      onError: (err) =>
        invalidateIntradayPreviewsOnRejection(queryClient, err, {
          withBidLimitMatrix: false,
        }),
    }),
  )
}
